import { ColumnDef } from '@tanstack/react-table';
import { ThemeChild } from '@toggle/toggle';
import { TFunction } from 'i18next';
import React from 'react';

import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import * as S from './ParentCategoryTable.styles';

export const COUNT_COLUMN_ID = 'count';
const NAME_COLUMN_ID = 'name';

export const getColumns = ({
  t,
  total,
}: {
  t: TFunction;
  total: number;
}): ColumnDef<ThemeChild>[] => {
  return [
    {
      id: NAME_COLUMN_ID,
      header: t(
        'widget:assetOverview.knowledgeGraph.themeExposure.tabs.parentCategory.investmentTheme',
        {
          count: total,
        }
      ),
      cell: props => {
        return (
          <S.ThemeWrapper>
            <ThemeLogoIcon
              name={props.row.original.theme.name}
              logo_url={props.row.original.theme.logo_url}
              isCondensed
              size={32}
              fallbackIcon={
                <S.FallbackLogo $size={32}>
                  {props.row.original.theme.name.charAt(0).toUpperCase()}
                </S.FallbackLogo>
              }
            />
            <div>{props.row.original.theme.name}</div>
          </S.ThemeWrapper>
        );
      },
      accessorFn: row => row.theme.name,
    },
    {
      id: COUNT_COLUMN_ID,
      header: t(
        'widget:assetOverview.knowledgeGraph.themeExposure.tabs.parentCategory.companiesInTheme'
      ),
      cell: props => {
        return <div>{props.row.original.company_count}</div>;
      },
      accessorFn: row => row.company_count,
    },
  ];
};
